import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { TransactionDateFilterKeyList } from '@/models/transaction/transaction-list-filter.model';
import { TransactionListSummary } from '@/models/transaction/transaction-list-summary.model';
import { TransactionListRequestModel } from '@/models/transaction/transaction-list.model';
import { clearObj, formatDatesInPayload } from '@marfa/bo-utils';

export default class GetTransactionListSummaryRequest extends ApiResourceMethod<TransactionListSummary> {
  public perform(wlSlug: string, params: TransactionListRequestModel) {
    const requestData = { ...params };

    if (requestData.filterList && Object.keys(requestData.filterList).length > 0) {
      requestData.filterList = formatDatesInPayload({
        payload: { ...requestData.filterList },
        isUnixToString: false,
        isIncludeTime: true,
      }, [
        TransactionDateFilterKeyList.CREATED_AT_FROM,
        TransactionDateFilterKeyList.CREATED_AT_TO,
        TransactionDateFilterKeyList.UPDATED_AT_FROM,
        TransactionDateFilterKeyList.UPDATED_AT_TO,
      ]);
    }

    return this.performer.requestWithMapper(
      {
        params: clearObj(requestData),
        url: `${wlSlug}/paymentListTotal`,
      },
      (payload: BaseResponse<TransactionListSummary>) => {
        return payload.data;
      },
    );
  }
}
